/* eslint no-irregular-whitespace: 0 */

const ReferFaq = [
  {
    title: 'General',
    content: [
      {
        question: 'I want to pass on the savings. Where can I get the personalised invite link?',
        response: `
          <p>A personalised invite link will appear on this page as soon as you’ve logged into your vuse.com account. If you are new to vuse.com, you must first create your account and then place a minimum order of $25 (excluding shipping and taxes). Only then will the link appear in your account. To send the link, you’ll have two options:</p>
          <ol>
          <li>Click on ‘Share by email’ to trigger your default email app, where a pre-written email will appear containing the invite link. Click 'Send' and it'll be on its way.</li>
          <li>Send the personalised invite link yourself by simply copying the link that appears in the space provided and pasting it into your own invite.</li>
          </ol>
        `
      },
      {
        question: 'Once I invite someone, how do I get my $20 in savings?',
        response: `
          <p>The invitee must (a) create their first account on vuse.com by using the personalised link you sent them, and (b) make a purchase within 30 days of creating their account. 14-days after both those conditions are met, we will send you an email confirming your $20 in savings.</p>
        `
      },
      {
        question: 'How do I know when I receive my own $20 in savings?',
        response: `
          <p>We will email you to confirm the $20 in savings has been added to your account 14 days after your invitee creates their account and places their first order with us. Note, her/his order must not be cancelled or refunded within 14 days. </p>
        `
      },
      {
        question: 'Where can I track my savings?',
        response: `
          <p>In your vuse.com account. Simply click on your name in the top right corner of the page, then “My account”, and finally the “Savings” tab.</p>
        `
      },
      {
        question: 'Can I transfer my savings to other vuse.com accounts?',
        response: `
          <p>Savings earned are non-transferable. They are only applicable to the account from which the successful invitation was made.</p>
        `
      },
      {
        question: 'Someone invited me to vuse.com and I’m interested in taking advantage of the savings. What’s next?',
        response: `
          <p>Follow the invite link and create a vuse.com account. You then have 30 days to apply your $20 savings to an order of at least $45 before tax.</p>
        `
      }
    ]
  },
  {
    title: 'Eligibility',
    content: [
      {
        question: 'How many people can I invite? How much can I redeem in savings?',
        response: `
          <p>There is a limit of 10 successful invites ($200 in savings) per user. </p>
        `
      },
      {
        question: 'Can I invite someone who already has a vuse.com account?',
        response: `You can only invite people who do not currently have an existing vuse.com account.`
      },
      {
        question: 'Someone invited me to vuse.com. Can I also pass on the savings to fellow adult nicotine consumers?',
        response: `Yes, once you’ve created a vuse.com account and placed a transaction.`
      }
    ]
  },
  {
    title: 'Redeeming Savings',
    content: [
      {
        question:
          'I’m passing on the savings to a friend or family member. Can I use my savings on all vuse.com products?',
        response: `
          <p>These savings can be applied to all vuse.com products but cannot be combined with other promotions and/or coupon codes. </p>
      `
      },
      {
        question: 'Do the savings and invite links expire? ',
        response: `
          <p>There is no expiry date on the invite links, but once your invitee creates an account, they have 30 days to redeem the $20 in savings.</p>
          <p>The savings you earn for each successful invite expires after 6 months. </p>
        `
      },
      {
        question: 'Can I apply my savings to shipping costs?',
        response: `
          <p>The savings earned do not apply to transactional costs like shipping and handling and taxes.</p>
        `
      },
      {
        question:
          'I was invited to vuse.com. I created my account and I now have 30 days to use my savings. Do I need to apply it to my first purchase?',
        response: `
          <p>No. Your saving can be applied to any order with a minimum of $45 made within 30 days of creating your vuse.com account.</p>
        `
      },
      {
        question: 'Can I combine my savings with other Vuse promotions/coupon codes?',
        response: `
          <p>No, you cannot use the savings earned with other promotions/coupon codes.</p>
        `
      },
      {
        question: 'Someone invited me to vuse.com. Can I apply my credit to any order?',
        response: `
          <p>No, your $20 savings can only be applied to minimum orders of $45 (before taxes and shipping) and must be used within 30 days from the date you create your account.</p>
        `
      },
      {
        question:
          "My invited friend created a Vuse account and made a purchase, but I still haven't received my credit. Why?",
        response: `
          <p>Your invited friend must make a minimum purchase of $25 (before taxes and shipping) in order for you to get your savings. Once they’ve placed their order, your $20 credit will be added to your account 14 after they have placed their order, if the order hasn't been cancelled or returned.</p>
        `
      }
    ]
  }
]

export default ReferFaq
